import React, { useEffect, useState } from 'react'
import ImgPhone1 from '@/assets/images/phone-1.png'
import ImgPhone2 from '@/assets/images/phone-2.png'
import ImgPhone3 from '@/assets/images/phone-3.png'
import ImgPhone4 from '@/assets/images/phone-4.png'
import ImgPhone5 from '@/assets/images/phone-5.png'

/* consola images */
import ps4Pro1 from '@/assets/images/ps4-pro-1.png'
import ps4Pro2 from '@/assets/images/ps4-pro-2.png'
import ps4Pro3 from '@/assets/images/ps4-pro-3.png'
import ps4Pro4 from '@/assets/images/ps4-pro-4.png'
import ps4Pro5 from '@/assets/images/ps4-pro-5.png'
import ps4Pro6 from '@/assets/images/ps4-pro-6.png'
import ps4Pro7 from '@/assets/images/ps4-pro-7.png'

import nintendo from '@/assets/images/nintendo-1.png'
import nintendo2 from '@/assets/images/nintendo-2.png'
import nintendo3 from '@/assets/images/nintendo-3.png'
import nintendo4 from '@/assets/images/nintendo-4.png'
import nintendo5 from '@/assets/images/nintendo-5.png'
import nintendo6 from '@/assets/images/nintendo-6.png'

import { Button } from '@nextui-org/react'
import { MdClose } from 'react-icons/md'
import GradientText from '@/components/GradientText/GradientText'
import NUIAlert from '@/components/Alert/Alert'
import { useParams } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { webApiService } from '@/services'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { currencyFormat } from '@/utils/currencyFormat'
import { imagesToBase64Array } from '@/utils/imagesToBase64Array'
import imageCompression from 'browser-image-compression'

const defaultImagesSmartPhone = [ImgPhone1, ImgPhone2, ImgPhone3, ImgPhone4, ImgPhone5, ImgPhone3]
const defaultConsoles = [ps4Pro1, ps4Pro2, ps4Pro3, ps4Pro4, ps4Pro5, ps4Pro6, ps4Pro7]
const defaultImagesNintendo = [nintendo, nintendo2, nintendo3, nintendo4, nintendo5, nintendo6]

let defaultImages: string[] = []

const IAEvaluation = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const [images, setImages] = useState<(File | null)[]>(Array(6).fill(null))
  const { id, slug } = useParams()
  const [data, setData] = useState<{ loading: boolean, result: any, cat: string, discount: number}>({ loading: false, result: null, cat: '', discount: 0 })
  const imageText = ctx.tradein.sbu === 'Consolas' ? ctx.tradein.brand === 'Nintendo' ? ['Imagen general', 'Imagen trasera', 'Imagen con soporte (si incluye)', 'Imagen inferior', 'Imagen superior', 'Dock o Frontal (lite)'] : ['Imagen general', 'Imagen inferior', 'Imagen lateral derecha', 'Imagen frontal', 'Imagen trasera', 'Imagen lateral izquierda'] : ['Imagen frontal', 'Imagen trasera', 'Imagen lateral derecha', 'Imagen inferior', 'Imagen superior', 'Imagen lateral izquierda']
  const isMacstoreMexico = slug === 'macstore' && import.meta.env.VITE_COUNTRY === 'MX'

  useEffect(() => {
    if (isMacstoreMexico) {
      imageText.splice(2, 4) // Remove all but first two images
      defaultImages = defaultImagesSmartPhone.slice(0, 2)
      setImages(Array(2).fill(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (ctx.tradein.sbu === 'Consolas') {
    switch (ctx.tradein.brand) {
      case 'Nintendo':
        defaultImages = defaultImagesNintendo
        break
      case 'Sony':
        defaultImages = defaultConsoles
        break
      default:
        defaultImages = defaultConsoles
        break
    }
  } else {
    defaultImages = defaultImagesSmartPhone
  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = event.target.files?.[0]
    if (!file) return

    const compressed = await imageCompression(file, {
      maxSizeMB: 0.8,
      maxWidthOrHeight: 800,
      useWebWorker: true
    })

    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = compressed
      console.log('🚀 ~ setImages ~ newImages:', newImages)
      return newImages
    })
  }

  const handleRemoveImage = (index: number) => {
    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = null
      return newImages
    })
  }

  async function consultaAI () {
    setData({ ...data, loading: true })
    const base64Images = await imagesToBase64Array(images)
    const payload = {
      metadata: { id_tradein: id, seller: slug, sbu: ctx.tradein.sbu === 'Consolas' ? 12 : 1 },
      images: base64Images
    }
    console.log('👀 payload:', payload)
    webApiService.saveIAResult(payload)
      .then((response) => {
        console.log('🚀 ~ .then ~ response:', response)
        setData({ ...data, loading: false, result: response.data, cat: response.data.categoria })
        saveCtx({ ...ctx, reload: true, tradein: { ...ctx.tradein, grade: response.data.categoria } })
      }).catch((error) => {
        if (error.status === 500) {
          enqueueSnackbar(error.response.data.message, { variant: 'error' })
        } else {
          enqueueSnackbar(error.message, { variant: 'error' })
        }
        setData({ ...data, loading: false })
        console.log('error ==>', error)
      })
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getIAEvaluation(Number(id)).then(res => {
      setData({ ...data, loading: false, result: res.data.result, cat: res.data.result.categoria })
    })
      .catch((error) => {
        setData({ ...data, loading: false })
        console.log('Error loading data :', error)
      })
  }

  useEffect(() => {
    if (ctx.tradein.grade_IA !== null) loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ctx.tradein.grade_IA])

  if (ctx.tradein.id_status === 1) {
    return <div />
  }

  return (
    <div className='bg-white rounded-lg shadow-lg p-4 h-full'>
      <div className='grid grid-cols-2 border-b-1 mb-2 '>
        <div><h6 className='font-bold text-xl pb-2'>Evaluación estética</h6></div>
        {data.result !== null ? <div className='text-end font-black text-lg' hidden={data.result.newDiscountAmount === undefined || slug === 'macstore' || slug === 'samsung-rom' || slug === 'conecta-peru' || slug === 'samsung-mx'}>Monto a descontar: <span className='text-primary'>{currencyFormat(Number(data.result.newDiscountAmount), import.meta.env.VITE_COUNTRY)}</span></div> : null}
      </div>
      <div className={(data.cat !== '' || ctx.tradein.grade_IA !== null) ? 'hidden' : 'flex p-2'}>
        <p className='mb-3 w-1/2'>Para iniciar la evaluación estética es necesario cargar todas las imágenes que se solicitan a continuación:</p>
        <div className='text-end w-1/2' hidden={images.filter(img => img === null).length > 0}><Button color='secondary' onClick={consultaAI} isLoading={data.loading}>Analizar</Button></div>
      </div>
      <div className='py-2 text-2xl font-bold' hidden={!data.loading || data.cat !== ''}><GradientText>Analizando los datos</GradientText></div>
      <div className='py-2' hidden={data.result === null}>
        <NUIAlert type={data.cat === 'A' ? 'success' : data.cat === 'B' || data.cat === 'C' ? 'warning' : data.cat === 'D' ? 'error' : 'error'}>
          {data.result !== null &&
            imageText.slice(0, isMacstoreMexico ? 2 : imageText.length).map((label, idx) => {
              const comentario = data.result[`comentario_img_${idx + 1}`]
              return comentario ? <p key={idx}>{label}: {comentario}</p> : null
            })}
          {/* {data.result !== null ? <p>Imagen frontal: {data.result.comentario_img_1}</p> : null}
          {data.result !== null ? <p>Imagen trasera: {data.result.comentario_img_2}</p> : null}
          {data.result !== null ? <p>Imagen lateral derecha: {data.result.comentario_img_3}</p> : null}
          {data.result !== null ? <p>Imagen inferior: {data.result.comentario_img_4}</p> : null}
          {data.result !== null ? <p>Imagen superior: {data.result.comentario_img_5}</p> : null}
          {data.result !== null ? <p>Imagen lateral izquierda: {data.result.comentario_img_6}</p> : null} */}
        </NUIAlert>
      </div>
      <div className={data.loading || data.cat !== '' || ctx.tradein.grade_IA !== null ? 'hidden' : 'grid grid-cols-6 gap-4'}>
        {(isMacstoreMexico ? imageText.slice(0, 2) : imageText).map((label, index) => (
          <div
            key={index} className={images[index] === null ? 'col-span-3 md:col-span-1 flex items-end justify-center aspect-[10/16] relative border-2 border-dashed border-blue-400 bg-cover bg-center before:bg-opacity-50 before:bg-white before:absolute before:h-full before:w-full' : 'col-span-3 md:col-span-1 flex items-end justify-center aspect-[10/16] relative border-2 border-dashed border-blue-400 bg-cover bg-center'}
            style={{ backgroundImage: `url(${images[index] ? URL.createObjectURL(images[index]!) : defaultImages[index]})` }}
          >
            {images[index] && (
              <Button
                className='absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-700'
                onClick={() => handleRemoveImage(index)}
                isIconOnly
              >
                <MdClose />
              </Button>
            )}
            <input type='file' accept='image/*' className='hidden' id={`file-input-${index}`} onChange={(e) => handleFileChange(e, index)} />
            <label htmlFor={`file-input-${index}`} className='mb-5' hidden={images[index] !== null}>
              <Button size='sm' color='warning' as='span'>{images[index] ? 'Reemplazar' : `Cargar ${label}`}</Button>
            </label>
          </div>
        ))}
      </div>
      <div className='text-end' hidden={data.result === null}>
        <Button color='primary' onClick={() => { setData({ ...data, result: null, cat: '' }); saveCtx({ ...ctx, tradein: { ...ctx.tradein, grade_IA: null } }) }} isLoading={data.loading}>Volver a Analizar</Button>
      </div>
    </div>
  )
}

export default IAEvaluation
